import { useEffect, useState } from "react";
import { api } from "../services/apiService";

export function CmsContent({ contentKey, fallbackTitle, fallbackBody }) {
  const [content, setContent] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get(`/cms/content/${contentKey}`)
      .then((response) => setContent(response.data.content))
      .catch(() => setContent(null))
      .finally(() => setLoaded(true));
  }, [contentKey]);

  if (!loaded) return null;

  const title = content?.title || fallbackTitle;
  const body = content?.body || fallbackBody;

  return (
    <>
      {title && <h3>{title}</h3>}
      {body.split("\n\n").map((paragraph, index) => (
        <p key={index} style={{ color: "var(--muted)", lineHeight: 1.8, marginTop: index === 0 ? 16 : 12 }}>{paragraph}</p>
      ))}
    </>
  );
}
